
import { Purchase } from "@/models/base";
import { PurchaseLedger } from "@/models/base/purchase-ledger";
import Vue from "vue";
import { IDataTableColumn } from "winfakt-vue-components";
import { printHumanFloat } from "@/utils/pretty-print";
import {LedgerAccount} from "@/models/ledger-account";
import {LedgerAccountService} from "@/services";
export default Vue.extend({
	data(){
		return {
			selectedItems: [] as PurchaseLedger[],
			ledgers: [] as LedgerAccount[]
		};
	},
	props: {
		purchase: {
			type: Object as ()=>Purchase,
			required: true
		},
		selectedItem: {
			type: Object as ()=>PurchaseLedger
		}
	},
	computed: {
		cols():IDataTableColumn[]{
			let purchase = this.purchase;
			return [
				{
					name: this.$ct("code").toString(),
					property: "LedgerCode",
					width: "80px"
				},
				{
					name: this.$ct("description").toString(),
					property: "LedgerAccount.Description",
					width: "200px",
				},
				{
					name: this.$ct("netto").toString(),
					property: "Amount",
					width: "80px",
					right: true,
					print(value:number):string{
						return  printHumanFloat(value/purchase.CurrencyRate);
					}
				},
				{
					name: this.$ct("vat-percentage-short").toString(),
					property: "VatPercent",
					width: "60px"
				},
				{
					name: this.$ct("comment").toString(),
					property: "Comment",
					width: "280px"
				}
			] as IDataTableColumn[];
		},
		compareFunction():(a:PurchaseLedger, b:PurchaseLedger)=>boolean{
			return (a:PurchaseLedger, b:PurchaseLedger):boolean => {
				return a==b;
			};
		},
	},
	watch: {
		selectedItems: {
			deep: true,
			handler(){
				if (this.selectedItems.length > 1) {
					this.selectedItems.splice(0, this.selectedItems.length-1);
				}
				if (this.selectedItems.length == 0 && this.purchase.Ledgers.indexOf(this.selectedItem) != -1) {
					this.$emit("selected-item", null);
					return;
				}
				if (this.selectedItems.length == 1 && this.selectedItems[0] != this.selectedItem) {
					this.$emit("selected-item", this.selectedItems[0]);
				}
			}
		},
		selectedItem: {
			immediate: true,
			handler(){
				if (this.purchase.Ledgers.indexOf(this.selectedItem) == -1) {
					this.selectedItems = [];
				}else {
					this.selectedItems = [this.selectedItem];
				}
			}
		},
		"purchase.Ledgers": {
			handler(){
				this.selectedItems.splice(0, this.selectedItems.length);
			}
		},
	},
	methods: {
		onClick(p:PurchaseLedger){
			let i = this.selectedItems.indexOf(p);
			if (i == -1) return;
			this.selectedItems.splice(i, 1);
		}
	},
	async mounted(){
		this.ledgers = await LedgerAccountService.fetchLedgerAccounts();
		this.purchase.Ledgers.map((l)=>{
			let f = this.ledgers.filter((x)=>x.Code==l.LedgerCode);
			if(!l.LedgerAccount){
				l.LedgerAccount = new LedgerAccount();
			}
			l.LedgerAccount.Description = f[0].Description;
			return l;
		});
	},
	i18nEx: {
		componentPrefix: "components.purchases"
	}
});
